import React from 'react';
import { Bar } from 'react-chartjs-2';
import 'chart.js/auto';
import { Chart as ChartJS, CategoryScale, LinearScale, Legend } from 'chart.js';
import data from '../graphdata.json';

ChartJS.register(CategoryScale, LinearScale, Legend);

const BarGraph = () => {
  const labels = [];
  const datasets = [];
  const lineDatasetData = [];
  const appearedlineDatasetData = [];
  const companyNames = Array.from(new Set(data.map(({ companyName }) => companyName)));

  // Define a set of distinct colors
  const distinctColors = [
    'rgba(0, 123, 255, 0.6)',
    'rgba(23, 162, 184, 0.6)',
    'rgba(40, 167, 69, 0.6)',
    'rgba(255, 80, 0, 0.6)',
    'rgba(156, 204, 101, 0.6)',
    'rgba(255, 161, 0, 0.6)',
    'rgba(31, 58, 147, 0.6)',
    'rgba(102, 51, 153, 0.6)',
    'rgba(64, 87, 135, 0.6)',
    'rgba(220, 53, 69, 0.6)',
    'rgba(25, 135, 84, 0.6)',
    'rgba(249, 168, 37, 0.6)',
    'rgba(15, 107, 135, 0.6)',
    'rgba(138, 141, 144, 0.6)',
  ];


  // Extract unique years as labels
  data.forEach(({ year }) => {
    if (!labels.includes(year)) {
      labels.push(year);
    }
  });

  // Generate datasets for each company
  companyNames.forEach((companyName, index) => {
    const backgroundColor = distinctColors[index % distinctColors.length];
    const datasetData = data
      .filter(({ companyName: cn }) => cn === companyName)
      .map(({ year, placements }) => placements);
    const appeareddatasetData = data
      .filter(({ companyName: cn }) => cn === companyName)
      .map(({ year, Total_Students_Appeared }) => Total_Students_Appeared);

    datasets.push({
      label: companyName,
      data: datasetData,
      backgroundColor,
      type: 'bar', // Set the type to 'bar' for the bar graph
    });

    // Calculate the total number of placements for each year and store it in lineDatasetData
    for (let i = 0; i < datasetData.length; i++) {
      if (lineDatasetData[i]) {
        lineDatasetData[i] += datasetData[i];
      } else {
        lineDatasetData[i] = datasetData[i];
      }
    }
    // Calculate the total students appeared for each year and store it in lineDatasetData
    for (let i = 0; i < appeareddatasetData.length; i++) {
      if (appearedlineDatasetData[i]) {
        appearedlineDatasetData[i] += appeareddatasetData[i];
      } else {
        appearedlineDatasetData[i] = appeareddatasetData[i];
      }
    }
  });

  // Create the dataset for the line curve
  const lineDataset = {
    label: 'Total Placements',
    data: lineDatasetData,
    fill: false,
    borderColor: 'rgba(255, 99, 132, 0.6)',
    backgroundColor: 'rgba(255, 99, 132, 0.6)',
    tension: 0.4,
    yAxisID: 'y',
    type: 'line', // Set the type to 'line' for the line curve
  };

  // Generate dataset for the total students appeared
  const totalStudentsAppearedDataset = {
    label: 'Total Students Appeared',
    data: appearedlineDatasetData, // Use the same data as lineDatasetData
    fill: false,
    borderColor: 'rgba(54, 162, 235, 0.6)',
    backgroundColor: 'rgba(54, 162, 235, 0.6)',
    tension: 0.4,
    yAxisID: 'y1',
    type: 'line', // Set the type to 'line'
  };

  const chartData = {
    labels,
    datasets: [...datasets, lineDataset, totalStudentsAppearedDataset],
  };


  const maxStudentsAppeared = Math.max(...appearedlineDatasetData);

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top', // Set the legend position to 'bottom'
      },
      title: {
        display: true, // Display the chart title
        text: "Placements in St. Thomas' over the years", // Set the chart title text
      },
    },
    scales: {
      x: {
        indexAxis: 'y',
        stacked: true,
      },
      y: {
        beginAtZero: true,
        stacked: true,
        display: true,
        precision: 0,
        max: Math.ceil(maxStudentsAppeared * 1.5), // Set the maximum value for the y scale
        ticks: {
          stepSize: Math.ceil(maxStudentsAppeared / 10), // Set the step size for the y scale
        },
      },
      y1: {
        beginAtZero: true,
        stacked: false,
        display: false,
        precision: 0,
        max: Math.ceil(maxStudentsAppeared * 1.5), // Set the maximum value for the y1 scale
        ticks: {
          stepSize: Math.ceil(maxStudentsAppeared / 10), // Set the step size for the y1 scale
        },
      },
    },
    // barThickness: 30,
  };

  return (
    <div>
      {/* <h1 style={{ fontWeight: 'bold', color: '#00004e', textAlign: 'center', borderBottom: '4px solid grey', paddingBottom: '10px', width: 'fit-content', margin: '0 auto' }}>Placement Overview</h1>
      <p style={{ textAlign: 'center' }}>The following is the year wise placement in St. Thomas' College of Engg & Tech</p> */}
      <div style={{ height: '500px' }}>
        <Bar data={chartData} options={chartOptions} />
      </div>
    </div>
  );
};

export default BarGraph;
